import { OrderHeaderURLs } from '../../../../baseComponents/TwinTable/InputTableLayout/types'

const useBuyDeliveryNoteHeaderURLs = () => {
    const orderHeaderURLs: OrderHeaderURLs = {
        createCost: '/api/app/order/buy/buyDeliveryNote/orderCost/createBuyDeliveryNoteCost',
        updateCost: '/api/app/order/buy/buyDeliveryNote/orderCost/updateBuyDeliveryNoteCost',
        deleteCost: '/api/app/order/buy/buyDeliveryNote/orderCost/deleteBuyDeliveryNoteCost',
        createFinancialRow: '/api/app/order/buy/buyDeliveryNote/orderFinancialRow/createBuyDeliveryNoteFinancialRow',
        updateFinancialRow: '/api/app/order/buy/buyDeliveryNote/orderFinancialRow/updateBuyDeliveryNoteFinancialRow',
        deleteFinancialRow: '/api/app/order/buy/buyDeliveryNote/orderFinancialRow/deleteBuyDeliveryNoteFinancialRow',
        createAccount: '/api/app/order/buy/buyDeliveryNote/orderAccount/createBuyDeliveryNoteAccount',
        updateAccount: '/api/app/order/buy/buyDeliveryNote/orderAccount/updateBuyDeliveryNoteAccount',
        deleteAccount: '/api/app/order/buy/buyDeliveryNote/orderAccount/deleteBuyDeliveryNoteAccount',
        createShipping: '/api/app/order/buy/shipping/createBuyShippingForDeliveryNote',
        updateShipping: '/api/app/order/buy/shipping/updateBuyShippingDeliveryNote',
        createVariable: '/api/app/order/buy/buyDeliveryNote/orderVariable/createBuyDeliveryNoteVariable',
        updateVariable: '/api/app/order/buy/buyDeliveryNote/orderVariable/updateBuyDeliveryNoteVariable',
        deleteVariable: '/api/app/order/buy/buyDeliveryNote/orderVariable/deleteBuyDeliveryNoteVariable',
        updateWorkingCenter: '/api/app/order/buy/buyDeliveryNote/updateBuyDeliveryNoteWorkingCenter',
        createUpdateProductTypes: '/api/app/order/buy/buyDeliveryNote/orderProductType/createUpdateBuyDeliveryNoteProductTypes',
    }
    return orderHeaderURLs
}

export default useBuyDeliveryNoteHeaderURLs